import React, { Component } from "react";
import gogoga from "./images/gogoga.png";

class Sidebar extends Component {
  render() {
    return (
      <div className="sidebar">
        <div className="logo">
     <img src={gogoga} alt="logo" className="image"/>
        </div>
        
        <p>Menu</p>
        <ul> 
          <li className="active">Dashboard</li>
          <li>Leads</li>
          <li>Itineraries</li>
          <li>Google Reviews</li>
          <li>Vouchers</li>
          <li>Accounts</li>
          <li>Reports</li>
          <li>Customer Support</li>
        </ul>
        <p>User Control</p>
        <ul> 
          <li>User Settings</li>
          <li>Master Settings</li>
          <li>HRM</li>
          <li>Assets Management</li>
        </ul>
        <p>PARTICIPANTS</p>
        <ul> 
          <li>User Settings</li>
          <li>Itenary Customers</li>
          <li>Partners</li>
          <li>Suppliers</li>
        </ul>
        <p>MISCELLANEOUS</p>
      </div>
    );
  }
}

export default Sidebar;
